module.exports = __webpack_public_path__ + "img/img_s2b2b_brand@3x.f1ab7503.png";